import React from "react";
import TapSelect from "../../../components/ui/TapSelect";
import InputCustomerSearch from "../../includes/ui/InputCustomerSearch";
import InputVendorSearch from "../../includes/ui/InputVendorSearch";

class AssetOwnerShip extends React.Component {
    constructor(props) {
        super(props);
    }

    tapSelectChange = (selectedOption, formName, fieldName) => {
        if (this.props.tapSelectChange) {
            this.props.tapSelectChange(selectedOption, formName, fieldName);
        }
    }
    
    render = () => {
        return (
            <>
                <div className="col-sm-3">
                    <label htmlFor="site_id" className="form-label">Ownership Category</label><br />
                    <TapSelect
                        changeEvent={(selectedOption) => { this.tapSelectChange(selectedOption, 'addAssetForm', 'owner_category'); }}
                        options={this.props.allOwnerCategoryList}
                        isSearchable={true}
                        isClearable={true}
                        value={this.props.allOwnerCategoryList.find(m => m.value === this.props.addAssetForm.owner_category)}
                        placeholder="Select Ownership Category"
                    />
                </div>
                {this.props.addAssetForm.owner_category === "owned" ? (
                    <div className="col-sm-3">
                        <label htmlFor="site_id" className="form-label">Asset Owner</label><br />
                        <TapSelect
                            changeEvent={(selectedOption) => { this.tapSelectChange(selectedOption, 'addAssetForm', 'owner_id'); }}
                            options={this.props.allOwnersList}
                            isSearchable={true}
                            isClearable={true}
                            value={this.props.allOwnersList.find(m => m.value === this.props.addAssetForm.owner_id)}
                            placeholder="Select Owner"
                        />
                    </div>
                ) : this.props.addAssetForm.owner_category === "customer" ? (
                    <div className="col-sm-3">
                        <label htmlFor="site_id" className="form-label">Asset Customer</label><br />
                        <InputCustomerSearch
                            changeEvent={(selectedOption) => { this.tapSelectChange(selectedOption, 'addAssetForm', 'owner_id'); this.setState({ searchedCustomer: selectedOption ? selectedOption : null })}}
                            value={this.props.searchedCustomer}
                        />
                    </div>
                ) : this.props.addAssetForm.owner_category === "vendor" ? (
                    <div className="col-sm-3">
                        <label htmlFor="site_id" className="form-label">Asset Vendor</label><br />
                        <InputVendorSearch
                            changeEvent={(selectedOption) => { this.tapSelectChange(selectedOption, 'addAssetForm', 'owner_id');  this.setState({ searchedVendor: selectedOption ? selectedOption : null })}}
                              value={this.props.searchedVendor ? { ...this.props.searchedVendor, label: this.props.searchedVendor.display_label } : null}
                        />
                    </div>
                ) : (
                    <div className="col-sm-3">
                        <label htmlFor="site_id" className="form-label">Asset Owner</label><br />
                        <TapSelect
                            changeEvent={(selectedOption) => { this.tapSelectChange(selectedOption, 'addAssetForm', 'owner_id'); }}
                            options={this.props.allOwnersList}
                            isSearchable={true}
                            isClearable={true}
                            value={this.props.allOwnersList.find(m => m.value === this.props.addAssetForm.owner_id)}
                            placeholder="Select Owner"
                        />
                    </div>
                )}
            </>
        )
    }
}

export default AssetOwnerShip;